import React, { useId, useState } from 'react';
import { Icon } from 'semantic-ui-react';
import './keySettingsV1022.css';

export default function KeySettingsDisclosureV1022({
  title,
  summary,
  actions,
  children,
  name,
  open,
  onOpenChange,
}) {
  const id = useId();
  const [expanded, setExpanded] = useState(false);
  const isOpen = open ?? expanded;
  const change = onOpenChange || setExpanded;
  return (
    <section className='key-settings-v1022' data-key-setting={name}>
      <div className='key-settings-heading-v1022'>
        <button
          type='button'
          className='key-settings-trigger-v1022'
          aria-expanded={isOpen}
          aria-controls={`${id}-body`}
          id={`${id}-heading`}
          onClick={() => change(!isOpen)}
        >
          <Icon name={isOpen ? 'chevron down' : 'chevron right'} />
          <span className='key-settings-title-v1022'>{title}</span>
          <span className='key-settings-summary-v1022'>{summary}</span>
        </button>
        {actions && <div className='key-settings-actions-v1022'>{actions}</div>}
      </div>
      <div
        id={`${id}-body`}
        aria-labelledby={`${id}-heading`}
        className='key-settings-body-v1022'
        hidden={!isOpen}
      >
        {children}
      </div>
    </section>
  );
}
